import template from './growl.html'

const component = {
	template,
	bindings: {
		reference: '@',
		limitMessages: '='
	},
	controller: function($scope, $interval, growl, growlMessages) {
		"ngInject"

		$scope.referenceId = $scope.reference || 0;
		growlMessages.initDirective($scope.referenceId, $scope.limitMessages);
		$scope.growlMessages = growlMessages;
		$scope.$watch('limitMessages', function (limitMessages) {
			var directive = growlMessages.directives[$scope.referenceId];
			if (!angular.isUndefined(limitMessages) && !angular.isUndefined(directive)) {
				directive.limitMessages = limitMessages;
			}
		});
		$scope.stopTimeoutClose = function (message) {
			if (!message.clickToClose) {
				angular.forEach(message.promises, function (promise) {
					$interval.cancel(promise);
				});
				if (message.close) {
					growlMessages.deleteMessage(message);
				} else {
					message.close = true;
				}
			}
		};
		$scope.alertClasses = function (message) {
			return {
				'alert-success': message.severity === 'success',
				'alert-error': message.severity === 'error',
				'alert-danger': message.severity === 'error',
				'alert-info': message.severity === 'info',
				'alert-warning': message.severity === 'warning',
				'icon': message.disableIcons === false,
				'alert-dismissable': !message.disableCloseButton
			};
		};
		$scope.wrapperClasses = function () {
			var classes = {};
			classes[growl.position()] = true;
			return classes;
		};
		$scope.computeTitle = function (message) {
			var ret = {
				'success': 'Success',
				'error': 'Error',
				'info': 'Information',
				'warn': 'Warning'
			};
			return ret[message.severity];
		};
	}
}

export default component;


// WEBPACK FOOTER //
// ./app/components/growl/growl.component.js